import Image from '../../src/legacy/Image';
export default Image;
